<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <dx-data-grid ref='refPurchaseGrid'
      :data-source='dokubInfoList'
      :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
      :hover-state-enabled = "true" :allowColumnResizing = 'true'
      column-resizing-mode = 'widget' :allow-column-reordering = "true"
      :height='gridHeight' :row-alternation-enabled="true"
      :focused-row-enabled="true"
      @focused-row-changed="onSelectionChanged"
      :auto-navigate-to-focused-row="false"
      key-expr="거래처코드"
      @toolbar-preparing='onToolbarPreparing'
    >
      <DxSearchPanel
        :visible="true"
        placeholder="검색..."
      />
      <DxExport
        :enabled="true"
        :file-name="excelFileName"
      />
      <DxFilterRow
        :visible="true"
        apply-filter="auto"
      />
      <DxColumn
        :allowEditing='true'
        caption="마감처명"
        data-field="거래처코드"
        :visible='true'
      >
          <DxLookup
          :data-source="customerLookup"
          display-expr="거래처명"
          value-expr="거래처코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing="true"
        caption="납품수량"
        data-field="납품수량"
        :visible='true'
        dataType="number"
        format='#,##0'
      >
      </DxColumn>

      <DxColumn
        :allowEditing="true"
        caption="도급금액"
        data-field="도급금액"
        :visible='true'
        dataType="number"
        format='#,##0'
      >
      </DxColumn>
      <DxColumn
        :allowEditing="true"
        caption="정산금액"
        data-field="정산금액"
        :visible='true'
        dataType="number"
        format='#,##0'
      >
      </DxColumn>
      <DxColumn
        :allowEditing="true"
        caption="차감금액"
        data-field="계산서금액"
        :visible='true'
        dataType="number"
        format='#,##0'
        :calculate-cell-value="calcTaxAmount"
      >
      </DxColumn>
      <DxSummary>
        <DxTotalItem
          value-format='#,##0'
          column="거래처코드"
          display-format="{0} (건)"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="납품수량"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="도급금액"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="정산금액"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="계산서금액"
          display-format="{0}"
        />
      </DxSummary>
      <DxMasterDetail
        :enabled="true"
        template="purchaseReCalc"
      />
      <template #purchaseReCalc="{ data: item }">
        <PurchaseReCalcSubGrid :item=item :baseDate="baseDate" goodsType="도급" @refresh-recalc-amount="onRefreshRecalcAmount"
        />
      </template>
      <dx-paging :enabled="false"/>
      <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
      <dx-sorting mode="multiple"/>
      <!-- <template #scrap-price-date>
        <div class="toolbar-label" style='font-size:1.2rem;margin-left:10px;'>
          <b>  스크랩단가 : {{scrapPrice}}원</b>
        </div>
      </template> -->
    </dx-data-grid>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, {
  DxScrolling, DxFilterRow, DxExport, DxMasterDetail,
  DxColumn, DxPaging, DxSorting, DxSearchPanel, DxLookup,
  DxSummary, DxTotalItem
} from 'devextreme-vue/data-grid'
import PurchaseReCalcSubGrid from './PurchaseReCalcSubGrid'

export default {
  name: 'DoKubSummary',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '외주품/하드웨어 정산'
        }
      ],
      excelFileName: null,
      selectedRow: null,
      dokubInfoList: null,
      yearArray: [],
      thisYear: null,
      monthArray: [],
      thisMonth: null,
      materialTypeLookup: null,
      itemTypeLookup: null,
      isExpandAll: false,
      selectedRowBefore: 'init',
      baseDate: null,
      customerLookup: null,
      doKubDate: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup,
    DxMasterDetail,
    DxSummary,
    DxTotalItem,
    PurchaseReCalcSubGrid
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.customerLookup = this.$store.getters.getCompanyInfo
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.materialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.doKubDate = `${AppLib.calcMonthFromToday(-1).substring(0, 7)}`
    this.init()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcTaxAmount (row) {
      return row.도급금액 + row.정산금액
    },
    init () {
      this.thisYear = AppLib.getThisYear()
      for (let i = this.thisYear; i >= 2021; i--) {
        this.yearArray.push({ 'year': i })
      }
      this.thisMonth = AppLib.getLastMonth()
      for (let i = 1; i <= 12; i++) {
        if (i > 0 && i < 10) {
          this.monthArray.push({ 'name': i + '월', value: '0' + i })
        } else {
          this.monthArray.push({ 'name': i + '월', value: '' + i })
        }
      }
      this.refreshPurchaseResult()
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>마감월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 80,
            value: this.doKubDate,
            type: 'date',
            calendarOptions: {
              maxZoomLevel: 'year',
              minZoomLevel: 'century'
            },
            max: `${AppLib.calcMonthFromToday(0).substring(0, 7)}`,
            dateSerializationFormat: 'yyyy-MM',
            displayFormat: 'yyyy-MM',
            onValueChanged: (args) => {
              this.doKubDate = args.value
              this.refreshPurchaseResult()
            }
          }
        }
      )
    },
    async refreshPurchaseResult () {
      let date = this.doKubDate.split('-')
      this.excelFileName = `${this.doKubDate}월_도급생산현황`
      this.baseDate = {
        fromDate: `${this.doKubDate}-01`,
        toDate: `${this.doKubDate}-${AppLib.getMonthLastDay(date[0], date[1])} 23:59:59`
      }

      this.$_sp.runNoEncodeFindProc('spFindAllDoKupBillByDateGbyCompany', this.baseDate)
        .then((data) => {
          this.dokubInfoList = this.$_sp.MakeModel(data)
          if (this.dokubInfoList.length === 0) {
            this.$snotify.info('해당월 마감된 도급자료가 없습니다. 도금생산 마감탭에서 해당월 마감하여 주세요.')
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // Detail subcell
    onRefreshRecalcAmount (recalcAmount) {
      this.selectedRow.정산금액 = recalcAmount
    }
  }
}
</script>

<style lang="scss">
</style>
